import { Icon as BlueprintIcon } from '@blueprintjs/core';
import * as React from 'react';

import { currentFeatureVersionSelector } from 'src/selectors/currentFeatureVersion';
import { getDataSourceIcon } from 'src/templates/icons';
import { useReduxSelector } from 'src/utils/hooks/useReduxSelector';

type DataSourceIconProps = {
  dataSourceType: string | null | undefined;
  size?: number;
  stardogVersion?: string;
  altText?: string;
};

export const DataSourceIcon: React.VFC<DataSourceIconProps> = ({
  dataSourceType,
  size = 32,
  stardogVersion: stardogVersionProp,
  altText,
}) => {
  const stardogVersionFromRedux = useReduxSelector(
    currentFeatureVersionSelector
  );
  const stardogVersion = stardogVersionProp ?? stardogVersionFromRedux;

  const dataSourceIcon = React.useMemo(() => {
    if (!dataSourceType) {
      return null;
    }
    return getDataSourceIcon({
      dataSourceType,
      stardogVersion,
    });
  }, [dataSourceType, stardogVersion]);

  if (!dataSourceType || !dataSourceIcon) {
    return null;
  }

  const alt = altText ?? dataSourceType;

  if (dataSourceIcon.isBlueprintIcon) {
    return <BlueprintIcon icon={dataSourceIcon.icon} size={size} />;
  }

  return (
    <img
      alt={alt}
      height={`${size}px`}
      src={dataSourceIcon.icon}
      width={`${size}px`}
    />
  );
};
